import { render, staticRenderFns } from "./examAnayles.vue?vue&type=template&id=2408eb4a&scoped=true"
import script from "./examAnayles.vue?vue&type=script&lang=js"
export * from "./examAnayles.vue?vue&type=script&lang=js"
import style0 from "./examAnayles.vue?vue&type=style&index=0&id=2408eb4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408eb4a",
  null
  
)

export default component.exports